import { DocumentationLayout } from '@/layouts/DocumentationLayout'
import { InstallationLayout } from '@/layouts/InstallationLayout'
import { Cta } from '@/components/Cta'
import { Steps } from '@/components/Steps'
import { setupPagesLayout } from '@/layouts/SetupPageLayout'
import { SetupDocumentationLayout } from '@/layouts/SetupDocsLayout'

export default function TailwindCli({}) {
  return (
    <InstallationLayout>
      <div className="relative z-10 prose mb-16 max-w-3xl">
        <p>
          The simplest and fastest way to get up and running with your apps🏕 without making a big
          effort is using our pre-built apps. Fit perfectly for someone who is trying to validate
          the idea and also totally new to this space.
          <p className="pl-5"> - You have an idea and want to quickly go to the market.</p>
          <p className="pl-5">
            {' '}
            - You might want to start first with MVP and customise the solution as per the idea
            validation results.{' '}
          </p>
          <p className="pl-5">
            {' '}
            - Every new signup would get an web app 🏕 hosted on our server. So, you can get a
            glimpse of your project, And test functionalities. The url is hosted under
            “APPNAME.tradly.co”
          </p>{' '}
          <br />
          We try to test & cover as many deployment platforms as possible through documentations,{' '}
          <a href="https://tradly.app/docs/netlify" target="_blank">
            check here
          </a>
          . but with Vercel we have native integrations.
        </p>
      </div>

      {/*
        <Cta
          label="Read the documentation"
          href="/docs/tailwind-cli"
          description={
            <>
              <strong className="text-gray-900 font-semibold">
                This is only the beginning of what’s possible with the Tailwind CLI.
              </strong>{' '}
              To learn more about everything it can do, check out the Tailwind CLI documentation.
            </>
          }
        />
      */}
    </InstallationLayout>
  )
}

TailwindCli.layoutProps = {
  meta: {
    title: 'Tradly Documentation - 2024',
  },
  Layout: SetupDocumentationLayout,
  allowOverflow: false,
}
